import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 -960 960 960"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M480-529 324-373q-11 11-28 11t-28-11-11-28 11-28l184-184q6-6 13-8.5t15-2.5 15 2.5 13 8.5l184 184q11 11 11 28t-11 28-28 11-28-11z" }, null, -1)
  ])))
}
export default { render: render }